/**
 * Text formatting utilities for markdown-like syntax
 */

/**
 * Replace ^word^ with <span>word</span>
 * @param {string} text - The text to format
 * @returns {string} Formatted HTML string
 */
export function formatCaretToSpan(text) {
	if (!text) return '';
	return text.replace(/\^(.+?)\^/g, '<span class="no-wrap">$1</span>');
}

/**
 * Replace *word* with <strong>word</strong>
 * @param {string} text - The text to format
 * @returns {string} Formatted HTML string
 */
export function formatStarToStrong(text) {
	if (!text) return '';
	return text.replace(/\*(.+?)\*/g, '<strong>$1</strong>');
}

/**
 * Strip caret markdown from text (remove ^)
 * @param {string} text - The text to format
 * @returns {string} Plain text without markdown
 */
export function stripCaretMarkdown(text) {
	if (!text) return '';
	return text.replace(/\^(.+?)\^/g, '$1');
}

/**
 * Strip star markdown from text (remove *)
 * @param {string} text - The text to format
 * @returns {string} Plain text without markdown
 */
export function stripStarMarkdown(text) {
	if (!text) return '';
	return text.replace(/\*(.+?)\*/g, '$1');
}
